// extracted by mini-css-extract-plugin
module.exports = {"menu":"_SCLk-L-","option":"_1ALDS95"};